import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import HeaderPanel from './../../HeaderPanel';
import GalleryHeroPanel from './GalleryHeroPanel';
import GalleryPanel from './GalleryPanel';
import FooterPanel from './../../FooterPanel';
import MapPanel from "./../../MapPanel";

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class GalleryPage extends React.Component {
  myRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    let self = this;
  }

  componentWillUnmount() {
  }

  render() {
    const { classes } = this.props;

    let self = this;

      return (
          <div className={classes.branding}>
              <HeaderPanel showLogo={true} ref={this.myRef} page={'gallery'} />
              <GalleryHeroPanel />
              <GalleryPanel />
              <MapPanel />
              <FooterPanel />
          </div>
      );
  }
}

export default withStyles(useStyles)(GalleryPage)
